// extracted by mini-css-extract-plugin
export default {"trade_card":"Credit_trade_card__WJqNB","card_info":"Credit_card_info__r5ck+"};